import React, { useEffect} from "react";
import { Link } from "react-router-dom";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Logout, UpdateAdminCredentials } from "src/Thunk/adminThunks";
import { clearMsg } from "src/Actions/Admin/adminActions";
const Settings = () => {
  const MySwal = withReactContent(Swal);
  const dispatch = useDispatch();
  const { user, msg} = useSelector((state) => state.admin);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { username: user.username, password: "" } });

  const handleCredentialUpdate = (data) => {
    if(data.password !== data.confirmPassword){
      MySwal.fire({
        icon: "error",
        title: "Password does not match",
      });
    }
    const userData = {
      Id:user.Id,
      password:data.password
    }
    dispatch(UpdateAdminCredentials(userData))
  }

  useEffect(() => {
     if(msg == "Password Updated"){
      MySwal.fire({
        icon: "success",
        title: msg,
        timer:1000
      });
      setTimeout(() => {
        dispatch(Logout());
        dispatch(clearMsg())
      },1200)
     }
  },[msg])

  return (
    <div>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <Row>
              <Col>
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0 text-info">SETTINGS</h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to="/dashboard">Home</Link>
                      </li>
                      <li className="breadcrumb-item active text-info">
                        Settings
                      </li>
                    </ol>
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={16}>
                <div className="card custom-shadow rounded-lg border my-2 mb-4">
                  <div className="card-body">
                    <h5 className="mb-4">Profile Settings</h5>
                    <Form onSubmit={handleSubmit(handleCredentialUpdate)}>
                      <Form.Group controlId="username" className="mb-3">
                        <Form.Label>UserName</Form.Label>
                        <Form.Control
                          type="text"
                          {...register("username")}
                          disabled
                        />
                      </Form.Group>

                      <Form.Group controlId="password" className="mb-3">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                          type="password"
                          autocomplete="new-password"
                          {...register("password", {
                            required: "Password is required",
                            minLength: {
                              value: 8,
                              message:
                                "Password must be at least 8 characters long",
                            },
                            maxLength: {
                              value: 15,
                              message: "Password must not exceed 15 characters",
                            },
                          })}
                        />
                        {errors.password && (
                          <p className="text-danger">
                            {errors.password.message}
                          </p>
                        )}
                      </Form.Group>
                      <Form.Group controlId="confirmPassword" className="mb-3">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                          type="password"
                          {...register("confirmPassword", {
                            required: "Confirm Password is required",
                            minLength: {
                              value: 8,
                              message:
                                "Password must be at least 8 characters long",
                            },
                            maxLength: {
                              value: 15,
                              message: "Password must not exceed 15 characters",
                            },
                          })}
                        />
                      </Form.Group>
                      {errors.confirmPassword && (
                        <p className="text-danger">
                          {errors.confirmPassword.message}
                        </p>
                      )}
                      <Button type="submit" variant="primary" className="my-2">
                        Update
                      </Button>
                    </Form>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
